export enum WebSocketsEvents {
    Workflow = 'workflow',
    Notification = 'notification',
    User = 'user',
    Exception = 'exception',
    ExploratoryMetrics = 'exploratory-metrics',
}
